import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Permission, hasPermission, hasAnyPermission, getRolePermissions } from '../types/roles';

export const usePermissions = () => {
  const { user } = useAuth();

  const userRole = useMemo(() => {
    return user?.is_admin ? 'admin' : 'inspector';
  }, [user]);

  const checkPermission = (permission: Permission): boolean => {
    return hasPermission(userRole, permission);
  };

  const checkAnyPermission = (permissions: Permission[]): boolean => {
    return hasAnyPermission(userRole, permissions);
  };

  const permissions = useMemo(() => {
    return getRolePermissions(userRole);
  }, [userRole]);

  const isAdmin = useMemo(() => {
    return user?.is_admin || false;
  }, [user]);

  return {
    checkPermission,
    checkAnyPermission,
    permissions,
    isAdmin,
    userRole,
  };
};
